import { toast } from "./toast"

export const UNDO_WINDOW_MS = 5000

interface UndoToastOptions {
  message: string
  /** Called if the user clicks "Deshacer" before the window elapses — restore the UI snapshot here. */
  onUndo: () => void
  /** Called once the window elapses without an undo — send the real request here. */
  onCommit: () => void
}

/**
 * Deferred-commit undo pattern (design.md — receta "CRUD de lista"): the
 * row disappears from the UI immediately, but the real network request is
 * held for `UNDO_WINDOW_MS` so "Deshacer" can cancel it outright instead of
 * compensating for an already-sent request.
 */
export function showUndoToast({ message, onUndo, onCommit }: UndoToastOptions): void {
  let settled = false
  const timer = setTimeout(() => {
    if (settled) return
    settled = true
    onCommit()
  }, UNDO_WINDOW_MS)

  toast(message, {
    duration: UNDO_WINDOW_MS,
    action: {
      label: "Deshacer",
      onClick: () => {
        if (settled) return
        settled = true
        clearTimeout(timer)
        onUndo()
      },
    },
  })
}
